export default {
  strict: true,
  namespaced: true,
  state: {
    geofence: {
      list: [],
      loading: false,
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'priority',
      // orderAsc: 0,
      search: ''
    }
  },
  mutations: {
    setGeofenceList (state, value) { state.geofence.list = value },
    setGeofenceLoading (state, value) { state.geofence.loading = value },
    setGeofenceMaxList (state, value) { state.geofence.maxList = value },
    setGeofenceCurrentPage (state, value) { state.geofence.currentPage = value },
    setGeofencePerPage (state, value) { state.geofence.perPage = value },
    setGeofenceOrder (state, value) { state.geofence.order = value },
    // setGeofenceOrderAsc (state, value) { state.geofence.orderAsc = value },
    setGeofenceSearch (state, value) { state.geofence.search = value }
  },
  sharedMutations: []
}
    


// WEBPACK FOOTER //
// ./src/store/services/geofence.js